module.exports = __webpack_public_path__ + "static/img/model-like2.fd668d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-like2.png
// module id = soWs
// module chunks = 36